import { ProgressBar } from '@wg/wows-react-uikit'
import classNames from 'classnames'
import routes from 'fe2/routes'
import { thousands } from 'helpers/formatting'
import { getItemObjectFromLocalStorage } from 'helpers/localStorage'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import Link from 'react-router/lib/Link'
import { roleNames } from 'roles'
import settings from 'settings'
import { playButtonSound } from '../../../web2ClientAPI/web2ClientAPI'
import styles from './Nav.scss'
import ParticleIcon from "~/Components/ParticleIcon/ParticleIcon";
import {iHavePermission, permissions} from "roles";

const propTypes = {
  currentAccount: PropTypes.shape({
    clanId: PropTypes.number,
    roleName: PropTypes.oneOf(roleNames),
    activeInvitesCount: PropTypes.number.isRequired,
    activeApplicationsCount: PropTypes.number.isRequired,
    leveling: PropTypes.number,
    accumulativeClanResource: PropTypes.number,
    isBonusActivated: PropTypes.bool,
  }).isRequired,
  root: PropTypes.string.isRequired,
  // used for rerender component after route path changed
  routePath: PropTypes.string,

  onRouteClick: PropTypes.func.isRequired,

  isBlured: PropTypes.bool,

  t: PropTypes.func.isRequired,
  finishedTaskCount: PropTypes.number,
  state: PropTypes.object,
}

class Nav extends React.PureComponent {
  constructor(props) {
    super(props)

    this.onRouteClick = this.onRouteClick.bind(this)
  }

  onRouteClick() {
    this.props.onRouteClick()
    playButtonSound()
  }

  render() {
    const { root, currentAccount, state } = this.props
    const linkItems = routes.filter((route) => !route.display || route.display(currentAccount, state))
      .map((route, index) => {
        let badgeValue = null
        let renderBadge = null
        let badgeClassNames = styles.badge
        const isLinkActive = window.location.pathname.includes(`${root}${route.path}`)

        if (route.badge === 'requests' && currentAccount.activeInvitesCount && !currentAccount.clanId) {
          badgeValue = currentAccount.activeInvitesCount
        } else if (route.badge === 'requests' && currentAccount.activeApplicationsCount && currentAccount.clanId) {
          badgeValue = currentAccount.activeApplicationsCount
        }
        if (badgeValue > 99) {
          badgeClassNames = classNames(styles.badge, styles.badgeBigNumber)
          badgeValue = '99+'
        }

        renderBadge = badgeValue ? (
          <span
            id={`${route.badge}-badge`}
            className={badgeClassNames}
          >
            {badgeValue}
          </span>
        ) : null

        const showRecommendationBadge = moment(settings.releaseFeaturesDates.recommendations).add(2, 'weeks').isAfter(moment())
        const sawRecommendations = getItemObjectFromLocalStorage('sawRecommendations')

        if (route.badge === 'recommendations' && showRecommendationBadge && !sawRecommendations[currentAccount.id]) {
          renderBadge = (
            <span
              id={`${route.badge}-badge`}
              className={styles.badgeNew}
            >NEW</span>
          )
        }

        const showClanRec2Badge = moment(settings.releaseFeaturesDates.clanrec2).add(2, 'weeks').isAfter(moment())
        const sawClanRec2 = getItemObjectFromLocalStorage('sawClanRec2')

        if (route.badge === 'new-recommendations' && showClanRec2Badge && !sawClanRec2[currentAccount.id]) {
          renderBadge = (
            <span
              id={`${route.badge}-badge`}
              className={styles.badgeNew}
            >NEW</span>
          )
        }

        const showClanTasksBadge = moment(settings.releaseFeaturesDates.darwin).add(4, 'weeks').isAfter(moment())
        const showClanTasks = getItemObjectFromLocalStorage('sawClanTasks')

        if (route.badge === 'tasks' && showClanTasksBadge && !showClanTasks[currentAccount.id]) {
          renderBadge = (
            <span
              id={`${route.badge}-badge`}
              className={styles.badgeNew}
            >NEW</span>
          )
        }
        const canClaimRewards = iHavePermission(permissions.CHANGE_SETTINGS, currentAccount)
        const hasFinishedTasks = route.badge === 'tasks' && this.props.finishedTaskCount > 0

        if (hasFinishedTasks && canClaimRewards) {
          renderBadge = <span className={styles.badgeTasksIcon}><ParticleIcon /></span>
        }

        if (settings.supply.isEnabled && route.path === 'profile' && !currentAccount.isBonusActivated) {
          const needResource = settings.supply.clanLevelingToAccountLeveling[currentAccount.leveling]
          const progressCompleted = currentAccount.accumulativeClanResource / needResource

          return (
            <Link
              to={`${root}${route.path}`}
              key={index}
              className={classNames(styles.link, styles['link__progressLink'], {
                [styles.linkCurrent]: isLinkActive,
                [styles.active]: hasFinishedTasks,
              })}
              onClick={this.onRouteClick}

            >
              <div>
                <div className={styles.title}>{route.title(currentAccount)}</div>
                <ProgressBar
                  size="small"
                  completed={progressCompleted}
                  isNavProgress
                />
                <div className={styles.progressText}>
                  <div className={styles.navClanResource}>{thousands(currentAccount.accumulativeClanResource)}</div>
                                    &nbsp;/&nbsp;
                                    <div className={styles.navClanResource}>{thousands(needResource)}</div>
                </div>
              </div>
            </Link>
          )
        }

        return (
          <Link
            to={`${root}${route.path}`}
            key={index}
            className={classNames(styles.link, {
              [styles.linkSpacer]: !!route.separator,
              [styles.linkCurrent]: isLinkActive,
              [styles.active]: hasFinishedTasks && canClaimRewards,
            })}
            onClick={this.onRouteClick}
            data-staff-name={route.badge}
          >
            {route.title(currentAccount)}
            {renderBadge}
          </Link>
        )
      })

    return (
      <nav
        className={`${styles.nav} ${styles.blurable} ${this.props.isBlured ? styles.isBlured : ''}`}
      >
        {linkItems}
      </nav>
    )
  }
}

Nav.propTypes = propTypes

const mapStateToProps = (state) => {
  return{
  isBlured: state.ReducerClanWars.isFromPort,
  finishedTaskCount: state.ReducerClanTasks.tasks.filter(task => task.isFinished && !task.isClaimed).length,
  state: {...state},
}}

export default connect(
  mapStateToProps,
)(translate()(Nav))